<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>Адреса Москва-Сити</strong>
                </CCardHeader>

                <CCardBody>
                    <table class="table">
                        <thead>
                            <th>Откуда</th>
                            <th>Куда</th>
                            <th>Время (минуты)</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in list" :key="item.id_to">
                                <td>
                                    {{ item.name_from }}
                                </td>
                                <td>
                                    {{ item.name_to }}
                                </td>
                                <td>
                                    <CInput
                                        v-model.number="item.time_to"
                                        type="text"
                                        placeholder="мин"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-2"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>
<script>
    export default {
        name: 'TowerTime',

        data: () => ({
            list: [],
        }),

        computed: {},

        mounted() {
            this.loadData();
        },

        methods: {
            async loadData() {
                try {
                    const { data } = await this.axios.get('/address');
                    const { data: towersTime } = await this.axios.get(`/tower-time/${this.$route.params.id}`);
                    this.prepareList(data, towersTime);
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            prepareList(list = [], towersTime = []) {
                const id = +this.$route.params.id;
                const mainTower = list.find(tower => tower.id === id);
                this.list = list.map(tower => ({
                    id_from: mainTower.id,
                    name_from: mainTower.name,
                    id_to: tower.id,
                    name_to: tower.name,
                    time_to: towersTime.find(towerTime => towerTime.id_to === tower.id)?.time_to || null,
                }));
            },

            async save() {
                const towers = this.list.map(tower => ({
                    id_from: tower.id_from,
                    id_to: tower.id_to,
                    time_to: tower?.time_to || null
                }));

                try {
                    const { data } = await this.axios.post('/tower-time', { towers });
                    if (data) {
                        this.goBack();
                    }
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router.push({ path: '/tower-time' });
            },
        },
    };
</script>
